<template>
  <div class="tpl-bd">
    <custom-dialog class="application-item-dialog" width="500px" :title="model.title" :visible="visible" v-on="$listeners">
      <div class="dialog-body">
        <el-form :model="form" :rules="rules" ref="form">
          <el-row>
            <el-col :span="24">
              <el-form-item :label="$t('base_application_item_dialog.ying_yong_lei_xing')" prop="appType">
                <custom-select v-model="form.appType" code="isynergy_cloud_appType"></custom-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row v-if="form.appType !== '1'">
            <el-col :span="24">
              <el-form-item :label="$t('base_application_item_dialog.suo_shu_ping_tai')" prop="parentId">
                <custom-select v-model="form.parentId" :filterable="true" url="basicApplicationPlatformList" :props="{ label: 'appName', value: 'appId' }"></custom-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item :label="$t('base_application_item_dialog.ying_yong_ming_cheng')" prop="appName">
                <el-input v-model="form.appName"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item :label="$t('base_application_item_dialog.ying_yong_bian_ma')" prop="appCode">
                <el-input v-model="form.appCode" :disabled="model.type === 'edit'"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item :label="$t('base_application_item_dialog.xian_shi_shun_xu')" prop="showOrder">
                <el-input type="number" :min="0" v-model.number="form.showOrder"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item :label="$t('Common.com_status')" prop="state">
                <el-switch v-model="form.state" :active-value="1" :inactive-value="0"></el-switch>
              </el-form-item>
            </el-col>
          </el-row>
          <el-col :span="24">
            <el-form-item :label="$t('base_application_item_dialog.ying_yong_miao_shu')" prop="appDesc">
              <el-input :rows="3" type="textarea" v-model="form.appDesc"></el-input>
            </el-form-item>
          </el-col>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="visible = false">{{ $t('Common.com_cancel') }}</el-button>
        <el-button type="primary" @click="saveApplication">{{ $t('Common.com_confirm') }}</el-button>
      </div>
    </custom-dialog>
  </div>
</template>

<script>
import apis from '@/utils/apis';
import dialogMixins from '@/mixins/dialog_mixins';

export default {
  mixins: [dialogMixins],
  data() {
    return {
      pushRoleList: [],
      menuId: '',
      form: {
        appId: '',
        // 应用名称
        appName: '',
        // 应用编码
        appCode: '',
        // 应用类型
        appType: '',
        // 所属平台
        parentId: undefined,
        // 是否上线
        state: '0',
        // 显示顺序
        showOrder: 0,
        // 应用描述
        appDesc: '',
        // 应用id
        // appId: ''
      },
    };
  },
  computed: {
    rules() {
      return {
        appName: [
          {
            required: true,
            message: this.$t('base_application_item_dialog.yymcbt'),
          },
          {
            max: 20,
            message: this.$t('Common.com_rules_length_max', [20]),
          },
        ],
        appCode: [
          {
            required: true,
            message: this.$t('base_application_item_dialog.yybmbt'),
          },
          {
            max: 50,
            message: this.$t('Common.com_rules_length_max', [50]),
          },
        ],
        appType: {
          required: true,
          message: this.$t('base_application_item_dialog.yylxbx'),
        },
        parentId: {
          required: true,
          message: this.$t('base_application_item_dialog.ssptbx'),
        },
        content: {
          max: 30,
          message: this.$t('Common.com_rules_length_max', [30]),
        },
        showOrder: {
          type: 'number',
          min: 0,
          message: this.$t('Common.com_rules_number_min', [0]),
        },
        pushChannel: {
          max: 100,
          message: this.$t('Common.com_rules_length_max', [100]),
        },
      };
    },
  },
  mounted() {
    this.initDialog();
  },
  methods: {
    // 初始化
    initDialog: function () {
      if (this.model.type === 'edit') {
        this.form = this.model.data;
        this.form.appId = this.model.data.appId;
        this.form.appType = `${this.model.data.appType}`;
        this.form.state = +this.model.data.state;
        this.form.parentId = this.model.data.parentId || '';
      }
    },
    getReqData() {
      const ret = { ...this.form };
      if (ret.appType === '1') {
        ret.parentId = undefined;
      }
      return ret;
    },
    // 确认保存菜单
    saveApplication: function () {
      this.$refs.form.validate((valid) => {
        if (!valid) {
          return;
        }
        if (this.model.type === 'add') {
          this.saveAddApp();
        }
        if (this.model.type === 'edit') {
          this.saveEditApp();
        }
      });
    },
    // 保存新增菜单
    saveAddApp: function () {
      this.$postJSON(apis.basicApplicationAdd, this.getReqData(), true).then(() => {
        this.$message({
          message: this.$t('Common.com_add_success'),
          type: 'success',
        });
        this.$emit('success');
        this.visible = false;
      });
    },
    // 保存编辑分组
    saveEditApp: function () {
      const reqData = this.getReqData();
      this.$postJSON(apis.basicApplicationUpdate, reqData, true).then(() => {
        this.$message({
          message: this.$t('Common.com_edit_success'),
          type: 'success',
        });
        this.$emit('success', reqData);
        this.visible = false;
      });
    },
  },
};
</script>

<style lang="scss">
.application-item-dialog {
  .dialog-body {
    overflow: hidden;
  }
}
</style>
